module.exports = __webpack_public_path__ + "static/media/Orientation-icon.d0b2f2bf.png";